import { HTTPClient } from "./Client";

const FotosApi = {
    async SalvarFoto(formData) {
        try {
            const response = await HTTPClient.post(`/Fotos/SalvarFoto`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao Salvar foto:", error);
            throw error;
        }
    },

    async ObterFoto() {
        try {
            const response = await HTTPClient.get(`/Fotos/ObterFotoPorUsuario/`, {
                responseType: "blob"
            })
            return response.data;

            
        } catch (error) {
            console.error("Erro ao obter informações do usuário:", error);
        }
    },

    async DeletarFoto() {
        try {

            const response = await HTTPClient.delete(`/Fotos/Remover/`);
              
            return response.data;

            
        } catch (error) {
            console.error("Erro ao obter informações do usuário:", error);
        }
    },
}

export default FotosApi;